// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ecade9ca","415":"bfacb29c"}[chunkId] + ".chunk.js";
};